import { constants } from '@eti/utils';
import { cabinBaggage } from '@eti/products';
import { useTranslation } from '@eti/providers';
import {
  resolveTravelerLabel,
  resolveCabinBaggageForTraveler,
} from '../../../widgets/cart/utils/baggage';
import type { TransformedCartTravelerPriceType } from '../../../common/types/transformations/models';
import useNameFormatter from '../../../common/custom-hooks/useNameFormatter';

const useSelectedCabinBaggagePerTraveler = (
  travelerPrices: TransformedCartTravelerPriceType[],
  products: any[],
  travelerFormProducts: any[],
) => {
  const { INFANT } = constants.ageTypes;
  const { t } = useTranslation();
  const { formatName } = useNameFormatter();

  const cabinBaggageBeingOffered = travelerFormProducts.find(
    (productBeingOffered) => productBeingOffered.id === cabinBaggage.id,
  );

  const { pieces, weight, weightUnit } = cabinBaggageBeingOffered?.sellSpecification || {};

  if (!cabinBaggageBeingOffered) {
    return null;
  }

  const cabinBaggageProduct = products.find((product: any) => cabinBaggage.id === product.id);

  if (!cabinBaggageProduct) {
    return [
      { label: t('Cart.CabinBaggage.Placeholder'), value: undefined, noBaggageSelected: true },
    ];
  }

  return travelerPrices.map((traveler) => {
    const travelerInProduct = cabinBaggageProduct.travelers.find(
      (productTraveler: any) => productTraveler.travelerId === traveler.travelerId,
    );

    const travelerLabel = resolveTravelerLabel(
      t,
      traveler.travelerId,
      formatName(traveler.firstName, traveler.lastName, traveler.fullName),
    );

    if (traveler.ageType === INFANT) {
      return {
        label: travelerLabel,
        value: t('Cart.CabinBaggage.ContactAirline'),
        noBaggageSelected: undefined,
      };
    }

    if (!travelerInProduct) {
      return {
        label: travelerLabel,
        value: t('Cart.CabinBaggage.Placeholder'),
        noBaggageSelected: undefined,
      };
    }

    return {
      label: travelerLabel,
      value: resolveCabinBaggageForTraveler(t, { pieces, weight, weightUnit }),
      noBaggageSelected: undefined,
    };
  });
};

export default useSelectedCabinBaggagePerTraveler;
